import {IArtist} from '@/types/common';

export const sortArtistsByDate = (a: IArtist, b: IArtist): number => {
  return (
    new Date(b.createdAtTime || '').getTime() -
    new Date(a.createdAtTime || '').getTime()
  );
};
